import { isGroupTableQuery } from 'owa-group-utils';
import { lazyGetRetentionPolicyTagListForGroupTableQuery } from 'owa-group-utils';
import { TableView } from 'owa-mail-list-store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export function getRetentionPolicyTagList(tableView: TableView) {
    if (tableView && isGroupTableQuery(tableView.tableQuery)) {
        const getRetentionPolicyTagListForGroupTableQuery = lazyGetRetentionPolicyTagListForGroupTableQuery.tryImportForRender();
        return getRetentionPolicyTagListForGroupTableQuery
            ? getRetentionPolicyTagListForGroupTableQuery(tableView.tableQuery)
            : [];
    }

    return getUserConfiguration().RetentionPolicyTags;
}
